/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const chevronUpDown = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="m12 20-4.5-3.6-.9 1.2L12 22l5.5-4.4-.9-1.2L12 20zm0-16 4.5 3.6.9-1.2L12 2 6.5 6.4l.9 1.2L12 4z" />
	</SVG>
);

export default chevronUpDown;
